// SMS opt-in shown under every phone field that leads to texts. The wording is
// registered with the 10DLC campaign (PDE-414); change both together.

type Props = {
  // 'self': the person typing is giving their own number.
  // 'host': an owner is adding a host's number for attendance texts.
  audience?: 'self' | 'host';
};

const SmsConsentNote = ({audience = 'self'}: Props) => (
  <div className='form-text fs-7 mt-2' data-testid='sms-consent-note'>
    {audience === 'host'
      ? 'diibs will text this number a verification code, then attendance confirmations for reservations at your restaurant. Only add a host who has agreed to receive them. '
      : 'By entering your phone number, you agree to receive verification codes and reservation texts from diibs. '}
    Msg frequency varies. Msg &amp; data rates may apply. Reply STOP to opt out, HELP for help. See our{' '}
    <a href='/terms-and-conditions' target='_blank' rel='noopener noreferrer'>
      Terms
    </a>{' '}
    and{' '}
    <a href='/privacy-policy' target='_blank' rel='noopener noreferrer'>
      Privacy Policy
    </a>
    .
  </div>
);

export default SmsConsentNote;
